/* 
  通过生日计算患者年龄封装
  create by 李智惠 2021-03-15
*/

function computeAge(birthday, obj={}) {
	if (birthday != undefined || birthday != null) {
    /*
     * 计算年龄之前的计算方法，有误，比如生日是1月31日，那么当天如果是2月1日，那么显示的也是1个月
		let today = new Date()
		let birth = new Date(birthday)
		let age = today.getFullYear()-birth.getFullYear()
		let currentMon = today.getMonth()
		let birthMon = birth.getMonth()
		let month = currentMon - birthMon
		let days = today.getDate() - birth.getDate();
		if(month<0||(month === 0 && days < 0)){ //包含日
		// if(month<0){ //不包含月
			obj.year=age-1
			obj.month=month+12
		}else{
			obj.year=age
			obj.month=month
		}
      */

    if (!birthday) return

    const birthDate = new Date(birthday)
    const currentDate = new Date()

    // 计算年龄
    let age = currentDate.getFullYear() - birthDate.getFullYear()
    const monthDiff = currentDate.getMonth() - birthDate.getMonth()
    const dayDiff = currentDate.getDate() - birthDate.getDate()

    if (monthDiff < 0 || (monthDiff === 0 && dayDiff < 0)) {
      age--
    }

    // 计算月份
    let months = monthDiff;
    if (dayDiff < 0) {
      months -= 1;
    }
    if (months < 0) {
      months += 12;
    }

    obj.year = age
    obj.month = months
		this.$forceUpdate();
	}
}
export default computeAge